__turbopack_context__.v({
  "buttonRows": "StyledConstants-module__pXdFFa__buttonRows",
  "buttonTabs": "StyledConstants-module__pXdFFa__buttonTabs",
  "dot": "StyledConstants-module__pXdFFa__dot",
  "dotsContainer": "StyledConstants-module__pXdFFa__dotsContainer",
  "name": "StyledConstants-module__pXdFFa__name",
  "profile": "StyledConstants-module__pXdFFa__profile",
  "quote": "StyledConstants-module__pXdFFa__quote",
  "reviewItem": "StyledConstants-module__pXdFFa__reviewItem",
  "reviewsContainer": "StyledConstants-module__pXdFFa__reviewsContainer",
  "scrollContainer": "StyledConstants-module__pXdFFa__scrollContainer",
});
